import React from 'react';
import { LogoIcon } from './Logo';

const PoweredBy = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-1 mt-6 opacity-60 hover:opacity-100 transition-opacity">
      <span className="text-[10px] text-slate-400 font-medium uppercase tracking-widest">
        Propulsé par
      </span>
      <div className="flex items-center gap-1.5">
        <LogoIcon className="w-5 h-5 text-slate-700" />
        <span className="text-sm font-bold text-slate-800">
          Event<span className="text-blue-600">Pro</span>
        </span>
      </div>
    </div>
  );
};

export default PoweredBy;